// Interpolacja cudzych encji: renderujemy stan sprzed ~120 ms, więc ruch jest płynny mimo ticków 10 Hz.
export interface Snapshot { t: number; x: number; y: number }

export class Interpolator {
  private buf: Snapshot[] = [];
  constructor(public delayMs = 120) {}

  push(t: number, x: number, y: number): void {
    this.buf.push({ t, x, y });
    if (this.buf.length > 20) this.buf.shift();
  }

  sample(now: number): [number, number] | null {
    if (!this.buf.length) return null;
    const rt = now - this.delayMs;
    if (rt <= this.buf[0].t) return [this.buf[0].x, this.buf[0].y];
    for (let i = this.buf.length - 1; i >= 0; i--) {
      const a = this.buf[i];
      if (a.t <= rt) {
        const b = this.buf[i + 1];
        if (!b) return [a.x, a.y];
        const k = (rt - a.t) / Math.max(1, b.t - a.t);
        return [a.x + (b.x - a.x) * k, a.y + (b.y - a.y) * k];
      }
    }
    return [this.buf[0].x, this.buf[0].y];
  }
}
